module.exports = __webpack_public_path__ + "img/pin-gold.2d480150.png";